console.log('=== NON-INTRUSIVE POPUP JS WITH SIMPLE SLIDER ===');

class HomepagePopup {
  constructor() {
    this.popup = document.getElementById('homepage-popup');
    this.metafieldsData = null;
    // Works on ALL pages now
    this.isHomepage = true; // Always initialize
    this.lastClickedButton = null;
    // NEW: Track if we're currently showing the popup
    this.isPopupOpen = false;
    // NEW: Track which product triggered the current popup
    this.currentPopupProductHandle = null;
    
    console.log('Is homepage:', this.isHomepage);
    
    if (this.isHomepage) {
      this.init();
    }
  }

  init() {
    console.log('Initializing popup...');
    this.loadMetafieldsData();
    this.setupPopupElements();
    this.setupEventListeners();
    // NEW: Setup popup click ignore
    this.setupPopupClickIgnore();
  }

  setupPopupClickIgnore() {
    // Listen for clicks inside the popup and mark them as "from popup"
    if (this.popup) {
      this.popup.addEventListener('mousedown', (e) => {
        // Mark that we're clicking inside the popup
        window.clickedInsidePopup = true;
        setTimeout(() => {
          window.clickedInsidePopup = false;
        }, 100);
        console.log('Click inside popup detected');
      });
    }
  }

  loadMetafieldsData() {
    try {
      const dataElement = document.getElementById('popup-metafields-data');
      if (dataElement) {
        this.metafieldsData = JSON.parse(dataElement.textContent);
        console.log('Metafields data loaded');
        
        const productsWithUpsells = this.getProductsWithUpsells();
        console.log('Products that should trigger popup:', productsWithUpsells);
      }
    } catch (error) {
      console.error('Error loading metafields:', error);
    }
  }

  getProductsWithUpsells() {
    if (!this.metafieldsData?.products) return [];
    return Object.entries(this.metafieldsData.products)
      .filter(([handle, data]) => data.popup_enabled)
      .map(([handle, data]) => ({ handle, productCount: data.popup_products.length }));
  }

  setupPopupElements() {
    if (!this.popup) {
      console.error('Popup element not found!');
      return;
    }

    this.closeButton = this.popup.querySelector('.popup-close');
    this.overlay = this.popup.querySelector('.popup-overlay');
    this.dontRemindCheckbox = this.popup.querySelector('.dont-remind-checkbox');
  }

  setupEventListeners() {
    // Close popup events
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.hidePopup());
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.hidePopup());
    }

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.style.display !== 'none') {
        this.hidePopup();
      }
    });

    // Track button clicks
    this.setupButtonTracking();
    
    // NON-INTRUSIVE: Only listen, don't intercept
    this.setupNonIntrusiveDetection();
  }

  setupButtonTracking() {
    // Listen for clicks on ALL add-to-cart buttons (grid + product pages)
    document.addEventListener('mousedown', (e) => {
      // SKIP if click was inside popup
      if (window.clickedInsidePopup) {
        console.log('Skipping button tracking - click was inside popup');
        return;
      }
      
      const button = e.target.closest(
        '.new-product-card__button, ' +
        '.s-new-products-grid__add-to-cart, ' +
        '.product-form__submit, ' +
        '[type="submit"][name="add"], ' +
        '.add-to-cart, ' +
        'button[data-add-to-cart]'
      );
      
      if (button) {
        this.lastClickedButton = button;
        console.log('Add to cart button tracked (all pages):', this.lastClickedButton);
        console.log('Button class:', button.className);
        console.log('Button text:', button.textContent);
      }
    });
  }

  setupNonIntrusiveDetection() {
    console.log('Setting up non-intrusive detection...');
    
    // Method 1: Listen for your existing notification system
    this.watchForNotifications();
    
    // Method 2: Listen for successful add to cart events
    this.watchForCartEvents();
    
    // Method 3: Watch for URL changes that indicate cart updates
    this.watchForCartPageRedirects();
  }

  watchForNotifications() {
    // Watch for your success notification to appear
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('cart-notification')) {
            if (node.classList.contains('success')) {
              console.log('✅ Success notification detected - product was added to cart');
              // Find which product was added by checking the clicked button
              this.findRecentlyAddedProduct();
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  watchForCartEvents() {
    // Listen for your existing component's events
    document.addEventListener('ajaxCart:afterAdd', (event) => {
      console.log('ajaxCart:afterAdd event received', event.detail);
      if (event.detail?.handle) {
        setTimeout(() => this.checkAndShowPopup(event.detail.handle), 1000);
      }
    });

    // Also listen for any custom events your system might dispatch
    document.addEventListener('cart:item-added', (event) => {
      console.log('cart:item-added event received', event.detail);
      if (event.detail?.productHandle) {
        setTimeout(() => this.checkAndShowPopup(event.detail.productHandle), 1000);
      }
    });
  }

  watchForCartPageRedirects() {
    // If your system redirects to cart page after success, watch for that
    let currentUrl = window.location.href;
    
    setInterval(() => {
      if (window.location.href !== currentUrl) {
        if (window.location.href.includes('/cart')) {
          console.log('Redirected to cart page - product was likely added');
          this.tryToDetectRecentAddition();
        }
        currentUrl = window.location.href;
      }
    }, 500);
  }

  findRecentlyAddedProduct() {
    console.log('Finding recently added product...');
    
    // Check if we're on a product page first
    const urlMatch = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (urlMatch) {
      const productHandle = urlMatch[1];
      console.log('✅ On product page, using URL handle:', productHandle);
      setTimeout(() => this.checkAndShowPopup(productHandle), 1000);
      return;
    }
    
    // Method 1: Use the tracked button to find the product
    if (this.lastClickedButton) {
      const productHandle = this.findProductHandleFromButton(this.lastClickedButton);
      if (productHandle) {
        console.log('Found product from tracked button:', productHandle);
        setTimeout(() => this.checkAndShowPopup(productHandle), 1000);
        this.lastClickedButton = null; // Reset for next time
        return;
      }
    }
    
    // Method 2: Fallback - find the most visible product card with upsells
    this.findMostVisibleProductWithUpsells();
  }

  findProductHandleFromButton(button) {
    console.log('=== Finding product handle from button ===');
    console.log('Button found:', button);
    
    // METHOD 1: Check if we're on a product page (get from URL)
    const urlMatch = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (urlMatch) {
      const productHandle = urlMatch[1];
      console.log('✅ Found handle from product page URL:', productHandle);
      return productHandle;
    }
    
    // METHOD 2: Check for homepage/grid layout (your existing code)
    const productCard = button.closest('.new-product-card');
    if (productCard) {
      // Check data attributes
      if (productCard.dataset.productHandle) {
        console.log('✅ Found handle from data-product-handle:', productCard.dataset.productHandle);
        return productCard.dataset.productHandle;
      }
      
      // Check product link
      const productLink = productCard.querySelector('a[href*="/products/"]');
      if (productLink) {
        const match = productLink.href.match(/\/products\/([^\/?]+)/);
        if (match) {
          console.log('✅ Found handle from product link:', match[1]);
          return match[1];
        }
      }
    }
    
    // METHOD 3: Check form data (for both grid and product pages)
    const form = button.closest('form');
    if (form) {
      // Check for product handle input
      const productHandleInput = form.querySelector('input[name="handle"], input[data-handle]');
      if (productHandleInput?.value) {
        console.log('✅ Found handle from form input:', productHandleInput.value);
        return productHandleInput.value;
      }
      
      // Check variant input for data-handle
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput?.dataset.handle) {
        console.log('✅ Found handle from variant data-handle:', variantInput.dataset.handle);
        return variantInput.dataset.handle;
      }
    }
    
    console.log('❌ Could not find product handle from any method');
    return null;
  }

  findMostVisibleProductWithUpsells() {
    console.log('Finding most visible product with upsells...');
    
    const productsWithUpsells = this.getProductsWithUpsells();
    if (productsWithUpsells.length === 0) {
      console.log('No products with upsells found');
      return;
    }
    
    // Find which product card is most visible in the viewport
    let mostVisibleProduct = null;
    let highestVisibilityScore = 0;
    
    productsWithUpsells.forEach(({ handle }) => {
      const productCard = this.findProductCardByHandle(handle);
      if (productCard) {
        const visibilityScore = this.calculateElementVisibility(productCard);
        console.log(`Product ${handle} visibility score: ${visibilityScore}`);
        
        if (visibilityScore > highestVisibilityScore) {
          highestVisibilityScore = visibilityScore;
          mostVisibleProduct = handle;
        }
      }
    });
    
    if (mostVisibleProduct && highestVisibilityScore > 0.3) { // At least 30% visible
      console.log('Most visible product with upsells:', mostVisibleProduct);
      setTimeout(() => this.checkAndShowPopup(mostVisibleProduct), 1000);
    } else {
      console.log('No sufficiently visible products with upsells found');
    }
  }

  findProductCardByHandle(handle) {
    // Find product card by checking data attributes and links
    // First check for grid cards
    const productCards = document.querySelectorAll('.new-product-card');
    
    for (const card of productCards) {
      // Check data attribute
      if (card.dataset.productHandle === handle) {
        return card;
      }
      
      // Check product link
      const productLink = card.querySelector('a[href*="/products/"]');
      if (productLink) {
        const match = productLink.href.match(/\/products\/([^\/?]+)/);
        if (match && match[1] === handle) {
          return card;
        }
      }
    }
    
    // If not found in grid, check if we're on the product page itself
    const currentHandle = window.location.pathname.match(/\/products\/([^\/?]+)/)?.[1];
    if (currentHandle === handle) {
      console.log('✅ Product is the current page product');
      // Return the main product container if needed
      return document.querySelector('.product, .product-main, [data-product-handle]');
    }
    
    return null;
  }

  calculateElementVisibility(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    
    // Calculate visible area
    const visibleTop = Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
    const visibleLeft = Math.max(0, Math.min(rect.right, windowWidth) - Math.max(rect.left, 0));
    const visibleArea = visibleTop * visibleLeft;
    const totalArea = rect.height * rect.width;
    
    return totalArea > 0 ? visibleArea / totalArea : 0;
  }

  tryToDetectRecentAddition() {
    console.log('Trying to detect recently added product...');
    const productsWithUpsells = this.getProductsWithUpsells();
    
    if (productsWithUpsells.length === 1) {
      // If only one product has upsells, assume it's that one
      const productHandle = productsWithUpsells[0].handle;
      console.log('Only one product with upsells, assuming it is:', productHandle);
      setTimeout(() => this.checkAndShowPopup(productHandle), 1000);
    } else if (productsWithUpsells.length > 0) {
      // If multiple, show popup for the first one (you might want to improve this)
      const productHandle = productsWithUpsells[0].handle;
      console.log('Multiple products with upsells, showing for first one:', productHandle);
      setTimeout(() => this.checkAndShowPopup(productHandle), 1000);
    }
  }

  checkAndShowPopup(productHandle) {
      // ===== PREVENT ON CART =====
  if (window.location.pathname.includes('/cart')) {
    console.log('On cart page - popup disabled');
    return;
  }
    console.log('=== CHECKING POPUP CONDITIONS ===');
    console.log('Product handle:', productHandle);
    
    if (this.shouldShowPopup(productHandle)) {
      console.log('✅ All conditions met - showing popup!');
      this.showPopup(productHandle);
    } else {
      console.log('❌ Popup conditions not met');
    }
  }

  shouldShowPopup(productHandle) {
    // NEW: QUICK FIX - Don't show ANY new popup if one is already open
    if (this.isPopupOpen) {
      console.log('❌ BLOCKED: Another popup is currently open');
      return false;
    }
    
    // NEW: Don't show popup if it's already open for this product
    if (this.isPopupOpen && this.currentPopupProductHandle === productHandle) {
      console.log('❌ Popup already showing for this product, preventing re-open');
      return false;
    }
    
    // Check localStorage block
    if (this.isPopupDisabled()) {
      console.log('Popup disabled by user preference');
      return false;
    }

    // Check if we have data for this product
    if (!this.metafieldsData?.products?.[productHandle]) {
      console.log('No metafield data for product:', productHandle);
      return false;
    }

    const productData = this.metafieldsData.products[productHandle];
    const shouldShow = productData.popup_enabled && 
                      Array.isArray(productData.popup_products) && 
                      productData.popup_products.length > 0;

    console.log('Popup conditions check:', {
      popup_enabled: productData.popup_enabled,
      has_products: productData.popup_products.length,
      final_result: shouldShow
    });

    return shouldShow;
  }

  isPopupDisabled() {
    const disabledUntil = localStorage.getItem('homepage_popup_disabled');
    if (!disabledUntil) return false;

    const now = new Date().getTime();
    return now < parseInt(disabledUntil);
  }

  showPopup(productHandle) {
    console.log('🎉 SHOWING POPUP FOR:', productHandle);
    const productData = this.metafieldsData.products[productHandle];
    
    if (!productData || !this.popup) {
      console.error('Missing product data or popup element');
      return;
    }

    // NEW: Set flags
    this.isPopupOpen = true;
    this.currentPopupProductHandle = productHandle;
    
    // Update popup content
    this.updatePopupContent(productData);
    
    // Show popup
    this.popup.style.display = 'block';
    this.popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Setup checkbox event
    this.setupCheckboxEvent();
    
    console.log('Popup displayed successfully!');
  }

  updatePopupContent(productData) {
    console.log('Updating popup content with:', productData);
    
    // Update header
    const icon = this.popup.querySelector('.popup-icon');
    const title = this.popup.querySelector('.popup-title');
    const subtitle = this.popup.querySelector('.popup-subtitle');
    const footerText = this.popup.querySelector('.footer-text');
    const productsContainer = document.getElementById('popup-products-container');

    if (icon && productData.popup_icon) {
      icon.src = productData.popup_icon;
      icon.style.display = 'block';
    } else if (icon) {
      icon.style.display = 'none';
    }

    if (title) title.textContent = productData.popup_title || 'You might also like...';
    if (subtitle) subtitle.textContent = productData.popup_subtitle || '';
    if (footerText) footerText.textContent = productData.popup_footer_text || '';

    // Render products with slider
    if (productsContainer && productData.popup_products) {
      this.renderProductsWithSlider(productsContainer, productData.popup_products);
    }
  }

  renderProductsWithSlider(container, products) {
    console.log('🎬 RENDERING PRODUCTS WITH SLIDER...');
    
    // Create the exact same structure as your Special Offers
    const sliderHtml = `
      <div class="special-offer-block">
        <div class="special-offer-block__controls">
          <button class="special-offer-block__control special-offer-block__control--prev js-slider-prev" aria-label="Previous products">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M15 18l-6-6 6-6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="special-offer-block__control special-offer-block__control--next js-slider-next" aria-label="Next products">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M9 18l6-6-6-6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        
        <div class="special-offer-slider" data-product-count="${products.length}">
          <div class="special-offer-slider__track js-slider-track">
            ${products.map((product, index) => this.createProductSlide(product, index)).join('')}
          </div>
        </div>
      </div>
    `;
    
    container.innerHTML = sliderHtml;
    
    // Initialize jQuery slider
    setTimeout(() => {
      this.initJQuerySlider(products.length);
      
      // Attach event listeners to the new cards
      this.attachPopupEventListeners();
    }, 300);
  }

  createProductSlide(product, index) {
    // Find pre-rendered card
    const preRenderedCard = document.querySelector(`#popup-preloaded-cards [data-product-handle="${product.handle}"]`);
    
    if (preRenderedCard) {
      // Clone the card
      const cardClone = preRenderedCard.cloneNode(true);
      
      // Update variant ID in form
      const form = cardClone.querySelector('.new-product-card__form');
      const variantInput = form?.querySelector('input[name="id"]');
      if (variantInput && product.selected_variant_id) {
        variantInput.value = product.selected_variant_id;
      }
      
      // Get the button
      const button = cardClone.querySelector('.new-product-card__button');
      if (button) {
        if (!product.available) {
          // ========== CRITICAL FIX ==========
          // 1. Update button text
          const isArabic = document.documentElement.lang === 'ar' || 
                          document.documentElement.dir === 'rtl';
          button.textContent = isArabic ? 'غير متوفر' : 'Out of Stock';
          
          // 2. Add proper disabled attributes
          button.disabled = true;
          button.setAttribute('disabled', 'disabled');
          button.classList.add('disabled', 'out-of-stock');
          
          // 3. Add inline styles to prevent clicking
          button.style.pointerEvents = 'none';
          button.style.cursor = 'not-allowed';
          button.style.opacity = '0.6';
          
          // 4. Disable the entire form
          if (form) {
            // Remove any event listeners by replacing the form
            const newForm = form.cloneNode(true);
            form.parentNode.replaceChild(newForm, form);
            
            // Add a custom submit handler that blocks out-of-stock
            newForm.addEventListener('submit', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              
              // Show error message
              if (typeof showQuickMessage === 'function') {
                showQuickMessage(
                  isArabic ? 'هذا المنتج غير متوفر حالياً' : 'This product is currently out of stock',
                  'error'
                );
              }
              
              return false;
            });
            
            // Also disable all inputs in the form
            const formInputs = newForm.querySelectorAll('input, select, button, textarea');
            formInputs.forEach(input => {
              input.disabled = true;
              input.setAttribute('disabled', 'disabled');
              input.style.pointerEvents = 'none';
            });
            
            // Add a class to the form itself
            newForm.classList.add('disabled-form');
            newForm.style.pointerEvents = 'none';
          }
          // ========== END CRITICAL FIX ==========
        } else {
          // Product is available
          button.textContent = 'Add to Cart';
          button.disabled = false;
          button.removeAttribute('disabled');
          button.classList.remove('disabled', 'out-of-stock');
          button.style.pointerEvents = '';
          button.style.cursor = '';
          button.style.opacity = '';
        }
      }
      
      return `<div class="special-offer-slider__slide">${cardClone.outerHTML}</div>`;
    } else {
      // Fallback
      const productCard = this.createSimpleProductCard(product);
      return `<div class="special-offer-slider__slide">${productCard.outerHTML}</div>`;
    }
  }

  initJQuerySlider(productCount) {
    console.log('🎯 INITIALIZING JQUERY SLIDER...');
    
    // Wait for jQuery to be available
    if (typeof jQuery === 'undefined') {
      console.log('jQuery not loaded yet, trying to load...');
      this.loadjQuery().then(() => {
        this.setupJQuerySlider(productCount);
      });
      return;
    }
    
    this.setupJQuerySlider(productCount);
  }

  loadjQuery() {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
      script.onload = () => {
        console.log('jQuery loaded successfully');
        resolve();
      };
      document.head.appendChild(script);
    });
  }

  setupJQuerySlider(productCount) {
    const $ = jQuery;
    
    $('.special-offer-slider').each(function() {
      const $slider = $(this);
      const $track = $slider.find('.js-slider-track');
      const $slides = $slider.find('.special-offer-slider__slide');
      const $prevBtn = $slider.closest('.special-offer-block').find('.js-slider-prev');
      const $nextBtn = $slider.closest('.special-offer-block').find('.js-slider-next');
      
      // Check if RTL
      const isRTL = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
      
      // If already initialized, skip
      if ($slider.data('initialized')) return;
      
      let currentIndex = 0;
      let slidesToShow = window.innerWidth <= 768 ? 1 : 2;
      
      console.log(`Initializing slider with ${$slides.length} slides, slidesToShow: ${slidesToShow}, RTL: ${isRTL}`);
      
      // Hide controls if not enough slides
      if ($slides.length <= slidesToShow) {
        $prevBtn.hide();
        $nextBtn.hide();
        $slider.data('initialized', true);
        return;
      }
      
      function getSlideWidth() {
        return $slides.first().outerWidth(true);
      }
      
      function updateSlider() {
        const slideWidth = getSlideWidth();
        // REVERSE DIRECTION FOR RTL
        const translateX = isRTL ? currentIndex * slideWidth : -currentIndex * slideWidth;
        $track.css('transform', 'translateX(' + translateX + 'px)');
        console.log('Slider moved to index:', currentIndex, 'translateX:', translateX, 'RTL:', isRTL);
      }
      
      function updateControls() {
        const maxIndex = $slides.length - slidesToShow;
        
        // REVERSE LOGIC FOR RTL
        if (isRTL) {
          // In RTL: prev button goes right (index++), next button goes left (index--)
          $prevBtn.prop('disabled', currentIndex >= maxIndex);
          $nextBtn.prop('disabled', currentIndex <= 0);
          
          if (currentIndex >= maxIndex) {
            $prevBtn.addClass('disabled');
          } else {
            $prevBtn.removeClass('disabled');
          }
          
          if (currentIndex <= 0) {
            $nextBtn.addClass('disabled');
          } else {
            $nextBtn.removeClass('disabled');
          }
        } else {
          // Normal LTR logic
          $prevBtn.prop('disabled', currentIndex <= 0);
          $nextBtn.prop('disabled', currentIndex >= maxIndex);
          
          if (currentIndex <= 0) {
            $prevBtn.addClass('disabled');
          } else {
            $prevBtn.removeClass('disabled');
          }
          
          if (currentIndex >= maxIndex) {
            $nextBtn.addClass('disabled');
          } else {
            $nextBtn.removeClass('disabled');
          }
        }
      }
      
      $prevBtn.off('click').on('click', function(e) {
        e.preventDefault();
        console.log('Prev button clicked, RTL:', isRTL);
        
        if (isRTL) {
          // In RTL: prev button should move right (increase index)
          const maxIndex = $slides.length - slidesToShow;
          if (currentIndex < maxIndex) {
            currentIndex += slidesToShow;
            if (currentIndex > maxIndex) currentIndex = maxIndex;
            updateSlider();
            updateControls();
          }
        } else {
          // Normal LTR: prev button moves left (decrease index)
          if (currentIndex > 0) {
            currentIndex -= slidesToShow;
            if (currentIndex < 0) currentIndex = 0;
            updateSlider();
            updateControls();
          }
        }
      });
      
      $nextBtn.off('click').on('click', function(e) {
        e.preventDefault();
        console.log('Next button clicked, RTL:', isRTL);
        
        if (isRTL) {
          // In RTL: next button should move left (decrease index)
          if (currentIndex > 0) {
            currentIndex -= slidesToShow;
            if (currentIndex < 0) currentIndex = 0;
            updateSlider();
            updateControls();
          }
        } else {
          // Normal LTR: next button moves right (increase index)
          const maxIndex = $slides.length - slidesToShow;
          if (currentIndex < maxIndex) {
            currentIndex += slidesToShow;
            if (currentIndex > maxIndex) currentIndex = maxIndex;
            updateSlider();
            updateControls();
          }
        }
      });
      
      // Handle window resize
      $(window).on('resize.popupSlider', function() {
        const wasMobile = slidesToShow === 1;
        slidesToShow = window.innerWidth <= 768 ? 1 : 2;
        const isMobile = slidesToShow === 1;
        
        // Reset to first slide when switching between mobile/desktop
        if (wasMobile !== isMobile) {
          currentIndex = 0;
        }
        
        updateSlider();
        updateControls();
      });
      
      // Initial setup
      updateSlider();
      updateControls();
      $slider.data('initialized', true);
      
      console.log('jQuery slider initialized successfully, RTL mode:', isRTL);
    });
  }

  attachPopupEventListeners() {
    console.log('🔗 ATTACHING EVENT LISTENERS TO POPUP CARDS...');
    
    // Find all forms in the popup
    const popupForms = document.querySelectorAll('#homepage-popup .new-product-card__form');
    console.log(`Found ${popupForms.length} forms in popup`);
    
    popupForms.forEach((form, index) => {
      console.log(`Setting up form ${index + 1}`);
      
      // Remove any existing listeners by cloning
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);
      
      // Get the button
      const button = newForm.querySelector('.new-product-card__button');
      
      // Attach the submit handler
      newForm.addEventListener('submit', (e) => {
        console.log('🎯 FORM SUBMIT IN POPUP - Calling handleAddToCart');
        e.preventDefault();
        e.stopImmediatePropagation();
        
        // Call YOUR handleAddToCart function - this should trigger all animations!
        if (typeof handleAddToCart === 'function') {
          handleAddToCart(e);
        } else {
          console.error('handleAddToCart function not found!');
          // Fallback: submit normally
          newForm.submit();
        }
      });
      
      // Also attach click to button as backup
      if (button) {
        button.addEventListener('click', (e) => {
          console.log('Button clicked in popup');
          // The form submit handler will catch this
        });
      }
    });
    
    console.log('Event listeners attached successfully');
  }

  createSimpleProductCard(product) {
    // Check if out of stock
    const isOutOfStock = !product.available;
    const isArabic = document.documentElement.lang === 'ar' || 
                    document.documentElement.dir === 'rtl';
    
    const buttonHtml = isOutOfStock ? 
      `<button type="button" class="new-product-card__button s-new-products-grid__add-to-cart disabled out-of-stock" disabled style="pointer-events: none; cursor: not-allowed; opacity: 0.6;">
        ${isArabic ? 'غير متوفر' : 'Out of Stock'}
      </button>` :
      `<button type="submit" class="new-product-card__button s-new-products-grid__add-to-cart">
        Add to Cart
      </button>`;
    
    // Fallback simple card
    const card = document.createElement('div');
    card.className = 'new-product-card';
    card.setAttribute('data-product-handle', product.handle);
    
    card.innerHTML = `
      <div class="new-product-card__clickable-area">
        <a href="${product.url}" class="new-product-card__link">
          <div class="new-product-card__image-container" style="height: 200px;">
            <img class="new-product-card__image" src="${product.featured_image}" alt="${product.title}" loading="lazy">
          </div>
          <div class="new-product-card__content">
            <h3 class="new-product-card__title">${product.title}</h3>
            <div class="new-product-card__price">
            ${product.compare_at_price && product.compare_at_price !== product.price ? 
              `<div class="price-container">
                <span class="actual-price">${product.price}</span>
                <span class="compare-price">${product.compare_at_price}</span>
              </div>` : 
              `<span class="regular-price">${product.price}</span>`
            }
          </div>
          </div>
        </a>
      </div>
      <form action="/cart/add" method="post" class="new-product-card__form ${isOutOfStock ? 'disabled-form' : ''}" 
            ${isOutOfStock ? 'onsubmit="return false;" style="pointer-events: none;"' : ''}>
        <input type="hidden" name="id" value="${product.selected_variant_id || ''}" ${isOutOfStock ? 'disabled' : ''}>
        ${buttonHtml}
      </form>
    `;
    
    return card;
  }

  setupCheckboxEvent() {
    if (this.dontRemindCheckbox) {
      this.dontRemindCheckbox.onchange = (e) => {
        if (e.target.checked) {
          this.disablePopupFor30Days();
        }
      };
    }
  }

  disablePopupFor30Days() {
    const thirtyDays = 30 * 24 * 60 * 60 * 1000;
    const disableUntil = new Date().getTime() + thirtyDays;
    localStorage.setItem('homepage_popup_disabled', disableUntil.toString());
    console.log('Popup disabled for 30 days');
  }

  hidePopup() {
    if (this.popup) {
      this.popup.style.display = 'none';
      this.popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // NEW: Clear flags when popup closes
      this.isPopupOpen = false;
      this.currentPopupProductHandle = null;
      console.log('Popup hidden');
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM Content Loaded - Starting popup system');
  window.homepagePopup = new HomepagePopup();
});

// ========== GLOBAL OUT-OF-STOCK PROTECTION ==========
// This blocks any attempts to add out-of-stock products from the popup
document.addEventListener('click', (e) => {
  // Check if click is inside the popup
  if (e.target.closest('#homepage-popup')) {
    // Find the clicked button
    const button = e.target.closest('.new-product-card__button, [type="submit"], .atc-button');
    
    if (button) {
      // Check if button is marked as out of stock
      const buttonText = button.textContent.trim().toLowerCase();
      const isOutOfStock = buttonText.includes('out of stock') || 
                          buttonText.includes('غير متوفر') ||
                          button.disabled ||
                          button.classList.contains('disabled') ||
                          button.classList.contains('out-of-stock');
      
      if (isOutOfStock) {
        console.log('🚫 BLOCKED: Attempt to add out-of-stock product from popup');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Show error message
        const isArabic = document.documentElement.lang === 'ar' || 
                        document.documentElement.dir === 'rtl';
        if (typeof showQuickMessage === 'function') {
          showQuickMessage(
            isArabic ? 'هذا المنتج غير متوفر حالياً' : 'This product is currently out of stock',
            'error'
          );
        }
        
        return false;
      }
    }
  }
}, true); // Use capture phase to catch events early